import { AutosuggestItem } from "./autosuggest-response";
import api from "../../utils/api";

const suggestions = new Map<string, AutosuggestItem[]>();

/** requests suggestions from url and caches responses */
export const getSuggestions = (url) => {
    if (suggestions.has(url)) {
        return Promise.resolve(suggestions.get(url));
    }
    return api<AutosuggestItem[]>(url).then((response: AutosuggestItem[]) => {
        suggestions.set(url, response);
        return response;
    });
};
